import type {FilterSuggestion, SuppliedFilterProviderOptions} from '@github-ui/filter-core'
import {NOT_SHOWN} from '@github-ui/filter-core'
import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {AppsIcon, RocketIcon} from '@primer/octicons-react'

const ARTIFACT_REGISTRY_FILTER_KEY = {
  displayName: 'Registry',
  key: 'artifact-registry',
  description: 'Filter by artifact registry',
  priority: 1,
  icon: AppsIcon,
}

const ARTIFACT_REGISTRY_VALUES: FilterSuggestion[] = [
  {value: 'jfrog-artifactory', displayName: 'jfrog-artifactory', priority: 1},
]

const artifactRegistryFilterOptions: SuppliedFilterProviderOptions = {
  filterTypes: {multiValue: false, exclusive: true, hasValue: false, valueless: false},
}

export class ArtifactRegistryFilterProvider extends SelectFilterProvider {
  constructor() {
    super(ARTIFACT_REGISTRY_FILTER_KEY, ARTIFACT_REGISTRY_VALUES, artifactRegistryFilterOptions)
  }
}

const HAS_DEPLOYMENTS_FILTER_KEY = {
  displayName: 'Deployments',
  key: 'deployments',
  description: 'Filter by deployment presence',
  priority: NOT_SHOWN,
  icon: RocketIcon,
}

/**
 * Hidden provider that contributes `has:deployments` to the auto-generated
 * has-filter. Priority is NOT_SHOWN so `deployments:` never appears as a
 * standalone suggestion.
 */
export class HasDeploymentsFilterProvider extends SelectFilterProvider {
  constructor() {
    super(HAS_DEPLOYMENTS_FILTER_KEY, [], {
      priority: NOT_SHOWN,
      filterTypes: {hasValue: true, valueless: true, multiValue: false},
    })
  }
}
